import { useState, useEffect } from 'react';

const useKeyboardNavigation = (itemCount, onSelect, options = {}) => {
    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [isKeyboardNavActive, setIsKeyboardNavActive] = useState(false);

    // Reset selection when itemCount changes (e.g., search results change)
    useEffect(() => {
        setSelectedIndex(-1);
        setIsKeyboardNavActive(false);
    }, [itemCount]);

    // Auto-scroll to selected item
    useEffect(() => {
        if (selectedIndex >= 0 && options?.listRef?.current) {
             // Find the element with the matching index attribute
             const selector = `[data-key-nav-index="${selectedIndex}"]`;
             const element = options.listRef.current.querySelector(selector);
             
             if (element) {
                 element.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
             }
        }
    }, [selectedIndex, options?.listRef]);

    const handleKeyDown = (e, getSelectedItem) => {
        if (itemCount === 0) return;

        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setIsKeyboardNavActive(true);
            setSelectedIndex(prev => {
                const nextIndex = prev + 1;
                return nextIndex >= itemCount ? prev : nextIndex;
            });
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setIsKeyboardNavActive(true);
            setSelectedIndex(prev => {
                const nextIndex = prev - 1;
                return nextIndex < 0 ? 0 : nextIndex;
            });
        } else if (e.key === 'Enter') {
            e.preventDefault();
            if (selectedIndex >= 0 && onSelect) {
                // Allow caller to retrieve the actual item based on index
                const selectedItem = getSelectedItem ? getSelectedItem(selectedIndex) : selectedIndex;
                if (selectedItem) {
                    onSelect(selectedItem);
                }
            }
        }
    };

    return {
        selectedIndex,
        setSelectedIndex,
        isKeyboardNavActive,
        setIsKeyboardNavActive,
        handleKeyDown
    };
};

export default useKeyboardNavigation;
